module.exports = __webpack_public_path__ + "img/logo_appsuite.35859dd4.png";